@if (sessionExpiry.visible()) {
  <div class="modal-backdrop session-expiry-backdrop" role="presentation">
    <div
      class="ent-modal session-expiry-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="sessionExpiryTitle"
      (click)="$event.stopPropagation()"
    >
      <div class="modal-header session-expiry-modal__header">
        <div class="session-expiry-modal__title-wrap">
          <span class="session-expiry-modal__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </span>
          <h2 id="sessionExpiryTitle">Session Expiring</h2>
        </div>
      </div>

      <div class="modal-body">
        <p class="session-expiry-message">
          Your access session is about to end for security.
          @if (sessionExpiry.secondsRemaining() > 0) {
            <span class="session-expiry-countdown">
              Time remaining:
              <strong>{{ sessionExpiry.secondsRemaining() }}s</strong>
            </span>
          }
        </p>
        <p class="session-expiry-hint">Stay logged in to continue without interruption.</p>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn-secondary"
          [disabled]="sessionExpiry.isRefreshing()"
          (click)="onLogout()"
        >
          Log out
        </button>
        <button
          type="button"
          class="btn-primary"
          [disabled]="sessionExpiry.isRefreshing()"
          (click)="onStayLoggedIn()"
        >
          @if (sessionExpiry.isRefreshing()) {
            Extending…
          } @else {
            Stay logged in
          }
        </button>
      </div>
    </div>
  </div>
}
